import { ChartModel } from './chart.model';
/**
 * Bar chart model definition
 */
export class BarChartModel extends ChartModel {
/**
 * Horizontal or vertical bar chart orientation. Default: 'vertical'.
 */
orientation?: string;
/**
 * If to show bar chart in grouped mode. Default: false.
 */
grouped?: boolean;
/**
 * It is icon constructor, which take values from Chart Component and create Chart Model object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super();
    Object.assign(this, values);
  }
}

function BarChartModel_tsickle_Closure_declarations() {
/**
 * Horizontal or vertical bar chart orientation. Default: 'vertical'.
 * @type {?}
 */
BarChartModel.prototype.orientation;
/**
 * If to show bar chart in grouped mode. Default: false.
 * @type {?}
 */
BarChartModel.prototype.grouped;
}

